import styles from "./boxSettings.module.css";

import ImgBuilder from "../../assets/ImgBuilder";
import { useTranslation } from "react-i18next";





const BoxAge = ({hdelay, settingsOptionsAge, imagesAdded, ageQuestion, ageWord, handleCompletion}) => {
  const { t } = useTranslation();
  
  return (
    <div className={`${styles.boxModeSelector}`} style={{ "--hdelay": hdelay }}>
        <p className={styles.callToActionBox}>
            {ageQuestion}
        </p>
        <div className={styles.settingsMainCon}>
            {settingsOptionsAge && 
            <div className={`${styles.settingsItem} ${styles.settingsItemAge}`}>
                <div className={styles.settingsItemName}>
                    {ageWord}
                <img alt="icon" className={styles.settingItemIcon} src={ImgBuilder.ageIcon}/>
                </div>

                <div className={styles.settingsItemContainer}>           
                {settingsOptionsAge.map((choice, idx_choice) => 
                    <div 
                        onClick={() => handleCompletion(choice)} 
                        key={idx_choice} 
                        className={`${styles.settingsItemContainerChoice} ${styles.settingsChoiceAge}`}
                    >
                        {imagesAdded[choice] && 
                            <img alt="backgrouundIcon" className={styles.settingAgeIcon} src={imagesAdded[choice]}/>
                        }
                        {choice}
                    </div>
                )}
                    <div className={styles.noAnswerContainer}>
                        <div 
                            onClick={() => handleCompletion("skipped")} 
                            className={`${styles.settingsItemContainerChoice}`}
                            style={{"flex": "none"}}
                        >
                        <div className={`${styles.circleSelected}`}></div>
                        {t("setup.select_age_ignore")}
                        </div>
                    </div>
                </div>

            </div>
            }
        </div>
    </div>
  );
};

export default BoxAge;

